import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IChildDetails } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepFamilyStep5(props: IVisaPrepForm) {
  const renderChildDetails = () => {
    const allChildDetails: React.ReactNode[] = [];
    if (props.children && props.children.length) {
      props.children.forEach((childDetail: IChildDetails, i: number) => {
        allChildDetails.push(
          <SummaryGroup title={`Child ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}-${i}`}
              value={childDetail.familyName}
              label="Family Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}-${i}`}
              value={childDetail.givenName}
              label="Given Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.DOB}-${i}`}
              value={childDetail.dob}
              label="Date of Birth"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={childDetail.nationality}
              label="Nationality"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GENDER}-${i}`}
              value={childDetail.gender}
              label="Gender"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.PLACE_OF_BIRTH}`}
              value={childDetail.placeOfBirth}
              label="Place of birth"
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.TRAVELLING_WITH}
              label="Is this person travelling with you?"
              value={childDetail.travellingWith}
            />
            {isPersonTravellingWith(childDetail.travellingWith) ? (
              <>
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.HAS_UK_VISA}
                  label={`Child ${i + 1}: Do they have a visa for the UK?`}
                  value={childDetail.ukVisa}
                />
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.HAS_PASSPORT}
                  label={`Child ${i + 1}: Do they have a Passport or Travel Document?`}
                  value={boolToYesNo(childDetail.hasPassport)}
                />
                {childDetail.hasPassport ? (
                  <SummaryRow
                    className={'visa-summary'}
                    key={VQ.PASSPORT_NUMBER}
                    value={childDetail.passportNumber}
                    label={`Child ${i + 1}: Current Passport or Travel Document Number:`}
                  />
                ) : null}
              </>
            ) : null}
          </SummaryGroup>,
        );
      });
    }
    return allChildDetails;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_DEPENDANT_CHILDREN}
        label={`Do you have any dependant children?`}
        value={boolToYesNo(props.hasDependantChildren)}
      />
      {props.hasDependantChildren ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            label="How many dependant children do you have?"
            value={props.children?.length}
          />
          <Box as="ol" pl={8}>
            {renderChildDetails()}
          </Box>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.CHILDREN_LIVING_WITH_YOU}
            label={`Are these children living with you currently?`}
            value={boolToYesNo(props.childrenLivingWithYou)}
          />
          {props.childrenLivingWithYou === false ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_ADDRESS}
                label="Contact Address"
                value={props.contactAddress}
              />
              <SummaryRow className={'visa-summary'} key={VQ.CONTACT_CITY} label="City" value={props.contactCity} />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_POSTCODE}
                label="Postcode"
                value={props.contactPostcode}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_COUNTRY}
                label="Country"
                value={props.contactCountry}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.CONTACT_NUMBER}
                label={'Contact number'}
                value={props.contactNumber}
              />
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep5;
